<form class="app-flex-form" (click)="debugForm(constructor.name)" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === emailAdminFilterKey.Action) {
      <mat-selection-list [formField]="formTree.action">
        @for (action of emailActionValues; track $index) {
          <mat-list-option [value]="action" (click)="$event.stopPropagation()">
            {{ action | emailActionDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === emailAdminFilterKey.Tag) {
      <mat-selection-list [formField]="formTree.tag">
        @for (tag of emailTagValues; track $index) {
          <mat-list-option [value]="tag" (click)="$event.stopPropagation()">
            {{ tag | emailTagDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === emailAdminFilterKey.Status) {
      <mat-selection-list [formField]="formTree.status">
        @for (status of emailStatusValues; track $index) {
          <mat-list-option [value]="status" (click)="$event.stopPropagation()">
            {{ status | emailStatusDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  }
</form>
